import { render } from "./QuestionsPage.vue?vue&type=template&id=7c5b8cc4&scoped=true"
import script from "./QuestionsPage.vue?vue&type=script&lang=js"
export * from "./QuestionsPage.vue?vue&type=script&lang=js"

import "./QuestionsPage.vue?vue&type=style&index=0&id=7c5b8cc4&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src310475096/src/AstopiaAdminPanel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c5b8cc4"]])

export default __exports__